"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevenLabsTimeoutError = void 0;
class ElevenLabsTimeoutError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, ElevenLabsTimeoutError.prototype);
    }
}
exports.ElevenLabsTimeoutError = ElevenLabsTimeoutError;
